import type { PlatformRepository } from '@zetyar/data-contracts'
import { createSupabasePlatformRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webPlatformRepository: PlatformRepository = createSupabasePlatformRepository(getSupabaseClient())
